import { Alert, Table } from "antd";
import "./TrainingHistory.css";
import useTrainingHistory from "./logic/useTrainingHistory";

const TrainingHistory = () => {

  const { 
    trainings, 
    isFetching,
    error, 
    columns,
    onChange,
    handleSearchChange
  } = useTrainingHistory();

  return (
    <>
      <div className="search-container">
        <input
          className="search-input"
          type="search"
          placeholder="Search..."
          onChange={handleSearchChange}
        />
      </div>
      <div className="training-content-container">
        {
          error ? <Alert message="An error has occurred" type="error" showIcon />
            :  <Table columns={trainings.data.length ? columns : []} dataSource={trainings.data} onChange={onChange} loading={isFetching}
                pagination={{ pageSize: trainings.meta?.take, total: trainings.meta?.itemCount, current: trainings.meta?.page }} />
        }
      </div>
    </>
  );
};

export default TrainingHistory;
